module.exports = __webpack_public_path__ + "img/组 3036.78246685.png";